export default "__VITE_ASSET__DNXrZWKL__"